import React, {useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {DefaultPlayer as Video} from 'react-html5video';
import YouTube from 'react-youtube';

import {getVideoUrl, getYouTubeIdFromUrl} from '@edume/bento/videoUtil.browser';

import '../../../../../../resources/styles/ReactHtml5Video.css';
import styles from './styles.module.scss';

const VideoPreview = ({url, source}) => {
  const [hover, setHover] = useState(false);

  if (!url) {
    return null;
  }
  if (source === 'youtube') {
    return (
      <div
        data-automation='youtube-video-preview'
        // iFrames and react-dropzone don't mix well, so we have to disable pointer events
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        styleName={'youtube-preview ' + (hover ? 'hover' : 'no-hover')}
      >
        <YouTube videoId={getYouTubeIdFromUrl(url)} className='youtube' />
      </div>
    );
  }
  if (source === 'cloudinary') {
    const videoUrl = getVideoUrl(url);
    return (
      <div styleName='media-container'>
        <Video
          key={url} // force rerender when video url updates
          controls={['PlayPause', 'Seek', 'Time', 'Volume']}
          poster={videoUrl.replace(/\.[^.]*$/, '.jpg')}
          width='100%'
        >
          <source
            src={videoUrl}
            type='video/mp4'
            data-automation='video-preview-source'
          />
        </Video>
      </div>
    );
  }
  return null;
};

VideoPreview.propTypes = {
  url: PropTypes.string,
  source: PropTypes.string,
};

export default CSSModules(VideoPreview, styles, {allowMultiple: true});
